import styled from 'styled-components'

import { palette, fonts, mediaQueries } from '../../styles/variables'
import { pushWithLanguageRoutes, translate } from '../../utils/translation'
import paymentMethodIcon from '../../styles/assets/alerts/payment_method.svg'
import Icon from '../icon/Icon'
import { PrimaryButton } from '../buttons/Buttons'
import {
  KISSMETRICS_TRACK_EVENTS,
  kissmetricsRecordingEvent,
  PROPERTY_NAMES,
  PROPERTY_VALUES,
} from '../../utils/kissmetrics'

import Modal, { ModalHeader, ModalContent, ModalFooter } from './Modal'

const Title = styled.span({
  color: palette.darkGray,
  fontSize: 20,
  lineHeight: '32px',
  fontWeight: 500,
  fontFamily: fonts.primaryMedium,
  textAlign: 'center',
  [mediaQueries.mobile]: {
    width: '100%',
    fontSize: '18px',
    marginLeft: 0,
    marginTop: 20,
    transform: 'translateX(0)',
  },
})

const Text = styled.span({
  display: 'block',
  color: palette.darkGray,
  fontFamily: fonts.primaryLight,
  fontSize: 14,
  textAlign: 'center',
  lineHeight: '25px',
  whiteSpace: 'pre-wrap',
  [mediaQueries.mobile]: {
    padding: '0 20px',
  },
})

const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
  },
})

const desktopStyle = {}

const mobileStyle = {
  width: '90%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
}

const PModalFooter = styled(ModalFooter)({
  background: palette.white,
  borderTop: `1px solid ${palette.lightGray50}`,
  [mediaQueries.mobile]: {
    flexDirection: 'column-reverse',
    justifyContent: 'center',
  },

  '& button': {
    [mediaQueries.mobile]: {
      marginTop: '15px',
    },
  },
})

export default ({ isOpen, ...rest }) => (
  <Modal
    isOpen={isOpen}
    desktopStyle={desktopStyle}
    mobileStyle={mobileStyle}
    {...rest}
  >
    <ModalHeader>
      <Row>
        <Icon src={paymentMethodIcon} transform="translateX(-50%)" />
        <Title>{translate('review_payment_method')}</Title>
      </Row>
    </ModalHeader>
    <ModalContent style={{ height: 'calc(100% - 200px)' }}>
      <Text>{translate('you_have_past_due_subscription')}</Text>
    </ModalContent>
    <PModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
      <PrimaryButton
        theme="orange"
        onClick={() => {
          pushWithLanguageRoutes('/settings/account_billing', {
            action: 'upgrade',
          })
          kissmetricsRecordingEvent(KISSMETRICS_TRACK_EVENTS.past_due_notice, {
            [PROPERTY_NAMES.update_payment]: PROPERTY_VALUES.update_payment,
          })
        }}
        tag={translate('update_payment_button')}
      />
    </PModalFooter>
  </Modal>
)
